import { LineChart } from "@mui/x-charts";

export default function StatGraph({series,interval}){
	const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
	const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

	const todayIndex = new Date().getDay();
	const thisMonthIndex = new Date().getMonth();

	const rotatedDays = days.slice(todayIndex+1 ).concat(days.slice(0, todayIndex+1 ));
	const rotatedMonths = months.slice(thisMonthIndex +1).concat(months.slice(0, thisMonthIndex +1))

	const displayMonth = interval === "Monthly";

	const rotatedSeries = JSON.parse(JSON.stringify(series));


		(series).forEach((line,index)=>{
			rotatedSeries[index]["data"] = displayMonth ?
				line["data"].slice(thisMonthIndex+1 ).concat(line["data"].slice(0, thisMonthIndex+1 ))
				: line["data"].slice(todayIndex+1 ).concat(line["data"].slice(0, todayIndex + 1));
		});

		console.log(rotatedSeries);




	return (
		<>
		<LineChart id="stat-graph"
			grid={{vertical:true}}
			xAxis={[{ data:displayMonth ? rotatedMonths : rotatedDays ,scaleType: "point" }]}
			series = {rotatedSeries}
			height={200}
		/>
		</>
	);
}



export class DataMaster {
	constructor(sales_d,subscription_d) {
		this.sales_data = sales_d;
		this.subscription_data = subscription_d;
		this.today = new Date();
	}

	get_data() {
		return this.sales_data;
	}

	get_graph_data(interval){
		let mainDataset = []

		mainDataset.push({"data": [],"connectNulls": true});

		// Plots for sales
		mainDataset.forEach((list)=>{
			switch(interval){
				case "Daily":
					list["data"].push(...Array(7).fill(0));
					this.sales_data.forEach((metrics)=>{
						let date = new Date(metrics.service_date);
						if((!list["id"] || list["id"] === metrics.buddy_id) && (this.today - date <= 7 * 24 * 60 * 60 * 1000)){
							list["data"][date.getDay()] += metrics.price ?? 0;
						}
					});
					break;

				case "Monthly":
					list["data"].push(...Array(12).fill(0));
					this.sales_data.forEach((metrics)=>{
						let date = new Date(metrics.service_date);
						if(!list["id"] || list["id"] === metrics.buddy_id){
							list["data"][date.getMonth()] += metrics.price ?? 0;
						}
					});
					break;
				default:
					console.log("unknown interval",interval);
					break;
			}
		});

		// Plots for subscriptions
		mainDataset.forEach((list)=>{
			switch(interval){
				case "Daily":
					// list["data"].push(...Array(7).fill(0));
					this.subscription_data.forEach((metrics)=>{
						let date = new Date(metrics.date_subscribed);
						if((!list["id"] || list["id"] === metrics.buddy_id) && (this.today - date <= 7 * 24 * 60 * 60 * 1000)){
							list["data"][date.getDay()] += metrics.price ?? 0;
						}
					});
					break;

				case "Monthly":
					// list["data"].push(...Array(12).fill(0));
					this.subscription_data.forEach((metrics)=>{
						let date = new Date(metrics.date_subscribed);
						if(!list["id"] || list["id"] === metrics.buddy_id){
							list["data"][date.getMonth()] += metrics.amount ?? 0;
						}
					});
					break;
				default:
					console.log("unknown interval",interval);
					break;
			}
		});

		return mainDataset;
	}

	get_sales_performance(ids){
		let payload = Object.fromEntries(ids.map(id => [id, { revenue: 0, jobs: new Set() }]));

		this.sales_data.forEach(entry => {
			if (payload.hasOwnProperty(entry.buddy_id)){
				payload[entry.buddy_id]["revenue"] += entry.price;
				payload[entry.buddy_id]["jobs"].add(entry.ticket_id);
			}
		});
		// payload
		Object.keys(payload).forEach(key => {
			payload[key]["jobs"] = payload[key]["jobs"].size;
		});
		return payload;
	}

	get_revenue_streams(){
		console.log("data",this.sales_data[0]);
		let repair =0;
		let  servicing =0;
		let workmanship =0;
		let rental=0;
		let insurance = 0;
		let subscriptions = this.subscription_data.reduce((sum, sub) => sum + (sub.amount ?? 0), 0);
		this.sales_data.forEach(element => {
			let service_name = element.item_name?.toLowerCase().trim();
			if (
				service_name.includes("air filter") ||
				service_name.includes("cabin filter") ||
				service_name.includes("servicing")
			){
				servicing += element.price;
			}else if (service_name.includes("workmanship")){
				workmanship += element.price;
			}else if (service_name.includes("rental")){
				rental += element.price;
			}else if (service_name.includes("insurance")){
				insurance += element.price;
			}else{
				repair += element.price;
			}
		});
		const totalSales = this.sales_data.reduce((sum, entry) => sum + (entry.price ?? 0), 0);
		// console.log("revenue streams", repair + servicing + workmanship + rental+insurance+subscriptions);
		// console.log("sales & subscriptions", totalSales + subscriptions);
		return {
			"Repairs & Parts" : repair,
			"Servicing" : servicing,
			"Workmanship" : workmanship,
			"Rentals" : rental,
			"Insurance" : insurance,
			"subscriptions" : subscriptions
		};
	}
}